export default __webpack_public_path__ + "static/media/icon-03.57348b90.svg";